import React from "react"
import { connect } from "react-redux"
import { firestoreConnect } from "react-redux-firebase"
import { compose } from "redux"
import NotificationAlert from "react-notification-alert"

import SimpleHeader from "components/Headers/SimpleHeader.js"
import { CustomPagination } from "components/Common"
import { addPromoCode } from "actions/promoCodeActions"
import { Constants } from "scripts"

import {
  Card,
  CardHeader,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  Button,
  Modal,
  CardBody,
  FormGroup,
  InputGroup,
  InputGroupText,
  Input,
  InputGroupAddon,
  Form,
  Col,
  Row,
  Table,
  Container,
} from "reactstrap"
import classnames from "classnames"
import Select from "react-select"

class PromoCodes extends React.Component {
  initialPromoCodeStates = {
    promoCodeTitle: "",
    promoCodeType: "",
    promoCodeDiscount: "",
    promoCodeLimit: "",
    promoCodeActive: true,
  }

  state = {
    start: 0,
    end: 0,
    formModal: false,
    ...this.initialPromoCodeStates,
  }

  _getPromoCodeCreationTime(time) {
    // time Is A Firestore Timestamp
    let ret = ""
    if (time) {
      let hours = time.toDate().getHours().toString()
      let minutes = time.toDate().getMinutes().toString()
      hours = hours.length === 1 ? "0" + hours : hours
      minutes = minutes.length === 1 ? "0" + minutes : minutes
      ret = `${hours}:${minutes}`
    }
    return ret
  }

  _handlePaginationClick(start, end) {
    if (start >= 0 && end >= 0) {
      this.setState({
        start,
        end,
      })
    }
  }

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    })
  }

  handleChange = (e) => {
    let name = e.target.name
    let value = e.target.value
    if (typeof value === "string") {
      value = value.trim()
    }
    if (name === "promoCodeTitle") {
      value = value.toUpperCase()
    }
    this.setState({
      [name]: value,
    })
  }

  handleTypeChange = (e) => {
    this.setState({
      promoCodeType: e.value,
    })
  }

  notify = (type, message, title) => {
    const options = Constants.NotificationAlertOptions(type, message, title)
    this.refs.notificationAlert.notificationAlert(options)
  }

  render() {
    const { promoCodes } = this.props
    const { start, end } = this.state
    // console.log(JSON.stringify(promoCodes, null, 4));
    return (
      <>
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <SimpleHeader name="Promo Codes" parentName="Promo Codes" />
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <Card>
                <CardHeader className="border-0">
                  <Row>
                    <Col xs="6">
                      <h3 className="mb-0">Promo Codes</h3>
                    </Col>
                    <Col className="text-right" xs="6">
                      <Button
                        className=" btn-round btn-icon btn-primary"
                        href="#"
                        color="primary"
                        id="tooltip969372949"
                        size="sm"
                        onClick={() => this.toggleModal("formModal")}
                      >
                        <span className="btn-inner--icon mr-1">
                          <i className="fas fa-plus" />
                        </span>
                        <span className="btn-inner--text">Add Promo Code</span>
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="text-center thead-light">
                    <tr>
                      <th className="sort" data-sort="status" scope="col">
                        Title
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Type
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        {/* Amount / Percentage */}
                        Discount
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Times Used
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Status
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Created On
                      </th>
                      <th scope="col" />
                    </tr>
                  </thead>
                  <tbody className="text-center list">
                    {promoCodes &&
                      promoCodes.length > 0 &&
                      promoCodes.slice(start, end).map((promoCode) => {
                        return (
                          <tr key={promoCode.id}>
                            <td>{promoCode.title}</td>
                            <td>{promoCode.type}</td>
                            <td>{promoCode.discount}</td>
                            <td>{promoCode.count || 0}</td>
                            <td>
                              {promoCode.active ? (
                                <span className="text-success">Active</span>
                              ) : (
                                <span className="text-danger">Disabled</span>
                              )}
                            </td>
                            <td>
                              {promoCode.time && (
                                <>
                                  {promoCode.time.toDate().toDateString()}
                                  <br />
                                  {this._getPromoCodeCreationTime(
                                    promoCode.time
                                  )}
                                </>
                              )}
                            </td>
                            <td className="text-right">
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  className="btn-icon-only text-light"
                                  color=""
                                  role="button"
                                  size="sm"
                                >
                                  <i className="fas fa-ellipsis-v" />
                                </DropdownToggle>
                                <DropdownMenu
                                  className="dropdown-menu-arrow"
                                  right
                                >
                                  <DropdownItem
                                    disabled={true}
                                    href="#fa"
                                    onClick={(e) => e.preventDefault()}
                                  >
                                    Edit
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </Table>
                <CustomPagination
                  pageSize={10}
                  dataLen={this.props.orders ? this.props.orders.length : 0}
                  stateCallback={this._handlePaginationClick.bind(this)}
                />
              </Card>
            </div>
            <Modal
              className="modal-dialog-centered"
              size="sm"
              isOpen={this.state.formModal}
              toggle={() => this.toggleModal("formModal")}
            >
              <div className="modal-body p-0">
                <Card className="bg-secondary border-0 mb-0">
                  <CardBody className="px-lg-5 py-lg-5">
                    <div className="text-center text-muted mb-4">
                      <small>Create A New Promo Code</small>
                    </div>
                    <Form role="form">
                      <FormGroup>
                        <InputGroup
                          className={classnames("input-group-merge mb-3", {
                            focused: this.state.promoCodeTitleFocus,
                          })}
                        >
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="fas fa-ticket-alt"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Promo Code Title"
                            type="text"
                            onChange={this.handleChange}
                            value={this.state.promoCodeTitle}
                            name="promoCodeTitle"
                            onFocus={(e) =>
                              this.setState({ promoCodeTitleFocus: true })
                            }
                            onBlur={(e) =>
                              this.setState({ promoCodeTitleFocus: false })
                            }
                            autoComplete="off"
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup
                        className={classnames("mb-4", {
                          focused: this.state.promoCodeDiscountSelectFocus,
                        })}
                      >
                        <Select
                          placeholder="Select Type"
                          defaultValue="1"
                          isSearchable={false}
                          onChange={(e) => this.handleTypeChange(e)}
                          options={[
                            { value: "percentage", label: "Percentage" },
                            { value: "direct", label: "Amount" },
                          ]}
                          onFocus={(e) =>
                            this.setState({
                              promoCodeDiscountSelectFocus: true,
                            })
                          }
                          onBlur={(e) =>
                            this.setState({
                              promoCodeDiscountSelectFocus: false,
                            })
                          }
                        />
                      </FormGroup>
                      {this.state.promoCodeType === "percentage" && (
                        <FormGroup>
                          <InputGroup
                            className={classnames("input-group-merge", {
                              focused: this.state.promoCodeDiscountFocus,
                            })}
                          >
                            <Input
                              placeholder="Number"
                              type="number"
                              onChange={this.handleChange}
                              name="promoCodeDiscount"
                              value={this.state.promoCodeDiscount}
                              onFocus={(e) =>
                                this.setState({ promoCodeDiscountFocus: true })
                              }
                              onBlur={(e) =>
                                this.setState({ promoCodeDiscountFocus: false })
                              }
                              autoComplete="off"
                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText>
                                <b>%</b>
                              </InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </FormGroup>
                      )}
                      {this.state.promoCodeType === "direct" && (
                        <FormGroup>
                          <InputGroup
                            className={classnames("input-group-merge", {
                              focused: this.state.promoCodeDiscountFocus,
                            })}
                          >
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <b>$</b>
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder="Amount"
                              type="number"
                              onChange={this.handleChange}
                              name="promoCodeDiscount"
                              value={this.state.promoCodeDiscount}
                              onFocus={(e) =>
                                this.setState({ promoCodeDiscountFocus: true })
                              }
                              onBlur={(e) =>
                                this.setState({ promoCodeDiscountFocus: false })
                              }
                              autoComplete="off"
                            />
                          </InputGroup>
                        </FormGroup>
                      )}
                      <FormGroup>
                        <InputGroup
                          className={classnames("input-group-merge mb-3", {
                            focused: this.state.promoCodeLimitFocus,
                          })}
                        >
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="fas fa-window-restore"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Limit"
                            type="number"
                            onChange={this.handleChange}
                            name="promoCodeLimit"
                            value={this.state.promoCodeLimit}
                            onFocus={(e) =>
                              this.setState({ promoCodeLimitFocus: true })
                            }
                            onBlur={(e) =>
                              this.setState({ promoCodeLimitFocus: false })
                            }
                            autoComplete="off"
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <b style={{ verticalAlign: "super" }}>Active: &nbsp;</b>
                        <label className="custom-toggle mr-1">
                          <input
                            onChange={() =>
                              this.setState({
                                promoCodeActive: !this.state.promoCodeActive,
                              })
                            }
                            defaultChecked={this.state.promoCodeActive}
                            name="promoCodeActive"
                            type="checkbox"
                          />
                          <span
                            className="custom-toggle-slider rounded-circle"
                            data-label-off="No"
                            data-label-on="Yes"
                          />
                        </label>
                      </FormGroup>
                      <div className="text-center">
                        <Button
                          className="my-4"
                          color="primary"
                          type="button"
                          onClick={(e) => {
                            e.preventDefault()
                            const {
                              promoCodeTitle,
                              promoCodeType,
                              promoCodeDiscount,
                              promoCodeLimit,
                              promoCodeActive,
                            } = this.state
                            if (
                              promoCodeTitle &&
                              promoCodeType &&
                              promoCodeDiscount &&
                              promoCodeLimit
                            ) {
                              const stateAndPropsForPromoCode = {
                                title: promoCodeTitle,
                                type: promoCodeType,
                                discount: promoCodeDiscount,
                                limit: parseInt(promoCodeLimit),
                                active: promoCodeActive,
                              }
                              this.props
                                .addPromoCode(stateAndPropsForPromoCode)
                                .then((isPromoCodeAdded) => {
                                  if (isPromoCodeAdded) {
                                    this.notify(
                                      "success",
                                      "Promo Code Added",
                                      "Notification"
                                    )
                                  } else {
                                    this.notify(
                                      "danger",
                                      "Promo Code Not Added",
                                      "Warning"
                                    )
                                  }
                                })
                              this.setState({
                                ...this.initialPromoCodeStates,
                                formModal: false,
                              })
                            } else {
                              this.notify(
                                "danger",
                                "Please Enter All The Details",
                                "Warning"
                              )
                            }
                          }}
                        >
                          Create Promo Code
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </div>
            </Modal>
          </Row>
        </Container>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  // console.log(state);
  return {
    promoCodes: state.firestore.ordered.promoCodes,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addPromoCode: (stateAndProps) => dispatch(addPromoCode(stateAndProps)),
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [
    {
      collection: `promoCodes`,
      storeAs: "promoCodes",
    },
  ])
)(PromoCodes)
